import { SVGProps } from 'react';

export const LevelerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M3.54 39.205c0-.598.484-1.083 1.082-1.083h42.156a1.083 1.083 0 1 1 0 2.167H4.622a1.083 1.083 0 0 1-1.083-1.084ZM3.643 33.095c-.097-.59.262-1.276.803-1.531l40.16-18.968c.54-.255 1.058.016 1.155.606.097.59-.262 1.277-.803 1.532L4.798 33.702c-.54.255-1.058-.016-1.155-.607Z'
      clipRule='evenodd'
    />
    <path
      fill='currentColor'
      fillRule='evenodd'
      d='M33.126 18.813c.58.149.928.74.78 1.319l-4.66 18.122a1.083 1.083 0 0 1-2.099-.54l4.66-18.122c.149-.58.74-.928 1.319-.78ZM43.99 13.283c-.211.56.072 1.185.632 1.396l1.997.75a1.083 1.083 0 1 0 .763-2.027l-1.997-.751a1.083 1.083 0 0 0-1.395.632Z'
      clipRule='evenodd'
    />
  </svg>
);
